// @flow
import { useQuery } from 'react-query';
import type { QueryOptions, UseQueryResult } from 'react-query';
import ApplicationFeesService from '../../services/applicationFeesService';

type ApplicationFees = {
  [string]: mixed,
};

type Params = {
  organizationId: ?string,
  propertyId: ?string,
  adultApplicantsCount: ?number,
  floorPlanId?: ?string,
  options?: QueryOptions<?ApplicationFees, mixed, ?ApplicationFees>,
};

export default function useApplicationFeesQuery({
  organizationId,
  propertyId,
  adultApplicantsCount,
  floorPlanId,
  options = {},
}: Params): UseQueryResult<?ApplicationFees, mixed> {
  const queryKey = [
    'useApplicationFeesQuery',
    organizationId,
    propertyId,
    adultApplicantsCount,
    floorPlanId,
  ];

  const enabled =
    !!organizationId &&
    !!propertyId &&
    typeof adultApplicantsCount === 'number' &&
    options.enabled !== false;

  return useQuery(
    queryKey,
    async () => {
      if (!organizationId || !propertyId) {
        return null;
      }

      const applicationFeesService = new ApplicationFeesService();
      return applicationFeesService.getAll(
        organizationId,
        propertyId,
        adultApplicantsCount,
        floorPlanId,
      );
    },
    {
      ...options,
      enabled,
      refetchOnWindowFocus: false,
      onError: (error) => {
        if (options.onError) {
          options.onError(error);
        }
      },
    },
  );
}
